/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ExceptionItemSearchResult = {
    id?: number;
    jan?: string;
    itemName?: string;
    departmentCode?: number;
    departmentName?: string;
    lowestPriceType?: ExceptionItemSearchResult.lowestPriceType;
    createdAt?: string;
    unit?: string;
};
export namespace ExceptionItemSearchResult {
    export enum lowestPriceType {
        EDLP = 'EDLP',
        SARATOKU = 'SARATOKU',
        CHOME = 'CHOME',
        COMPETITOR = 'COMPETITOR',
        FRESHNESS = 'FRESHNESS',
        POS_CHANGED = 'POS_CHANGED',
        ORIGINAL_SELLING_PRICE_CHANGE = 'ORIGINAL_SELLING_PRICE_CHANGE',
        NULL = 'NULL',
        EMPTY = 'EMPTY',
    }
}

